import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import ChoiceStore from './choice-store';
import ChoiceActionsFactory from './choice-actions-factory';
export default class CheckboxChoices extends React.Component {    
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    componentDidUpdate(){
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    getChoices(){
        const questionId = this.props.question.questionId;
        let choicesMap = this.props.question.choices.map( (choice,index) => {
            const key = `choice-${questionId}-${choice.choiceId}`;
            let componentProps = {
                key: key,
                choice: choice,
                name: "qna-"+questionId,
                questionId: questionId,
                choiceId: key
            }
            return ( <Choice {...componentProps} /> )
        });

        return choicesMap;

    }
    render() { 
        let choices = this.getChoices();
        if(choices.length==0) return false;
        return(
            <ul className="choices-container checkbox-choices">
            { choices }
            </ul>
        )
    }
}
CheckboxChoices.propTypes={
    question: React.PropTypes.object.isRequired
}
CheckboxChoices.defaultProps={
}

class Choice extends Reflux.Component{
    constructor(props) {
        super(props);
        this.state = {}
        this.store = ChoiceStore.get(props.choice,true,props.questionId);
        this.ChoiceActions = ChoiceActionsFactory.get(props.questionId);
    }
    componentDidMount() {
        this.bindEvents();
    }
    componentDidUpdate(prevProps, prevState){
        this.bindEvents();
    }
    componentWillUnmount(){
        this.store.stopListeningToAll();
    }
    bindEvents(){
        let $this = $(ReactDOM.findDOMNode(this));
        let $checkboxEl = $this.find('input[type="checkbox"]');
        let $labelEl = $this.find('label');
        $checkboxEl.off('change.QNA').on('change.QNA',(e)=>{
            e.preventDefault();
            let el = e.currentTarget;
            let isSelected = $(el).is(':checked');
            this.ChoiceActions.change(this.state,isSelected);
        });
        
        $labelEl.off('click.QNA').on('click.QNA',(e)=>{
            $checkboxEl.trigger('change.QNA');
        })
    }
    render() {
        let className = "choice-item";
        className += this.state.selected ? " active" : "";
        let choiceId = this.props.choiceId;
        let inputProps = {
            type: "checkbox",
            checked: this.state.selected,
            name: this.props.name,
            value: this.state.choiceId,
            id: choiceId
        }
        let text = {
            __html: this.state.choiceText
        }
        return(
            <li className={className}>
                <label htmlFor={choiceId}>
                    <input {...inputProps}   />
                    <div className="inputBorder">
                    <span className="checkbox-button">
                        <span></span>
                    </span>
                    </div>
                    <span className="choice-text" dangerouslySetInnerHTML={text}></span>
                </label>
            </li>
        )
    }
}

Choice.propTypes={
    choice: React.PropTypes.object.isRequired,
    name: React.PropTypes.string.isRequired,
    questionId: React.PropTypes.number.isRequired,
    choiceId: React.PropTypes.string.isRequired
}
Choice.defaultProps={
}


// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/choices/checkbox.jsx